import './styles.css';
document.addEventListener('DOMContentLoaded', function () {
    // Get form elements
    const estadoSelect = document.getElementById('gas-form-estado');
    const cidadeSelect = document.getElementById('gas-form-cidade');
    const bairroSelect = document.getElementById('gas-form-bairro');
    const searchForm = document.querySelector('.gas-form-menu');
    const resultsContainer = document.getElementById('gas-form-results');
    const backButton = document.getElementById('gas-form-back-button');
    // Verificar se os elementos existem
    if (!estadoSelect || !cidadeSelect || !bairroSelect || !searchForm || !resultsContainer || !backButton) {
        console.error('Elementos necessários não encontrados no DOM');
        return;
    }
    // Store all gas stations data
    let allGasStations = [];
    let filteredStations = [];
    // Group data by UF, Cidade, and Bairro
    let stateMap = {};
    let cityMap = {};
    let neighborhoodMap = {};
    // Fetch gas stations data from JSON file
    fetch('/public/json/gas-form.json')
        .then(response => response.json())
        .then((data) => {
        // Store the data
        allGasStations = data;
        // Process the data to create mappings
        processGasStationsData(data);
        // Populate the estado dropdown
        populateEstadoDropdown();
    })
        .catch(error => {
        console.error('Error loading gas stations data:', error);
    });
    // Process the gas stations data to create mappings
    function processGasStationsData(data) {
        // Reset maps
        stateMap = {};
        cityMap = {};
        neighborhoodMap = {};
        // Process each gas station
        data.forEach(station => {
            const uf = station.UF;
            const cidade = station.Cidade;
            const bairro = station.Bairro;
            // Add to state map
            if (!stateMap[uf]) {
                stateMap[uf] = [];
            }
            if (!stateMap[uf].includes(cidade)) {
                stateMap[uf].push(cidade);
            }
            // Add to city map
            const cityKey = `${uf}-${cidade}`;
            if (!cityMap[cityKey]) {
                cityMap[cityKey] = [];
            }
            if (!cityMap[cityKey].includes(bairro)) {
                cityMap[cityKey].push(bairro);
            }
            // Add to neighborhood map
            const neighborhoodKey = `${uf}-${cidade}-${bairro}`;
            if (!neighborhoodMap[neighborhoodKey]) {
                neighborhoodMap[neighborhoodKey] = [];
            }
            neighborhoodMap[neighborhoodKey].push(station);
        });
        // Sort all arrays
        for (const uf in stateMap) {
            if (Object.prototype.hasOwnProperty.call(stateMap, uf)) {
                stateMap[uf].sort();
            }
        }
        for (const cityKey in cityMap) {
            if (Object.prototype.hasOwnProperty.call(cityMap, cityKey)) {
                cityMap[cityKey].sort();
            }
        }
    }
    // Populate the estado dropdown
    function populateEstadoDropdown() {
        // Clear existing options except the first one
        while (estadoSelect.options.length > 1) {
            estadoSelect.remove(1);
        }
        // Get all unique UFs and sort them
        const ufs = Object.keys(stateMap).sort();
        // Add options for each UF
        ufs.forEach(uf => {
            const option = document.createElement('option');
            option.value = uf;
            option.textContent = uf;
            estadoSelect.appendChild(option);
        });
    }
    // Enable cidade select when estado is selected
    estadoSelect.addEventListener('change', function () {
        const selectedUF = estadoSelect.value;
        // Clear and disable bairro select
        clearDropdown(bairroSelect);
        bairroSelect.disabled = true;
        // Clear results
        clearResults();
        if (selectedUF) {
            // Enable and populate cidade select
            cidadeSelect.disabled = false;
            populateCidadeDropdown(selectedUF);
        }
        else {
            // Disable cidade select if no UF is selected
            clearDropdown(cidadeSelect);
            cidadeSelect.disabled = true;
        }
    });
    // Enable bairro select when cidade is selected
    cidadeSelect.addEventListener('change', function () {
        const selectedUF = estadoSelect.value;
        const selectedCidade = cidadeSelect.value;
        // Clear results
        clearResults();
        if (selectedCidade) {
            // Enable and populate bairro select
            bairroSelect.disabled = false;
            populateBairroDropdown(selectedUF, selectedCidade);
        }
        else {
            // Disable bairro select if no cidade is selected
            clearDropdown(bairroSelect);
            bairroSelect.disabled = true;
        }
    });
    // Handle bairro selection
    bairroSelect.addEventListener('change', function () {
        // Clear results
        clearResults();
    });
    // Populate the cidade dropdown based on selected estado
    function populateCidadeDropdown(uf) {
        // Clear existing options except the first one
        clearDropdown(cidadeSelect);
        // Get cities for the selected UF
        const cities = stateMap[uf] || [];
        // Add options for each city
        cities.forEach(city => {
            const option = document.createElement('option');
            option.value = city;
            option.textContent = city;
            cidadeSelect.appendChild(option);
        });
    }
    // Populate the bairro dropdown based on selected cidade
    function populateBairroDropdown(uf, cidade) {
        // Clear existing options except the first one
        clearDropdown(bairroSelect);
        // Get neighborhoods for the selected city
        const cityKey = `${uf}-${cidade}`;
        const neighborhoods = cityMap[cityKey] || [];
        // Add options for each neighborhood
        neighborhoods.forEach(neighborhood => {
            const option = document.createElement('option');
            option.value = neighborhood;
            option.textContent = neighborhood;
            bairroSelect.appendChild(option);
        });
    }
    // Clear a dropdown's options except the first one
    function clearDropdown(selectElement) {
        while (selectElement.options.length > 1) {
            selectElement.remove(1);
        }
        selectElement.selectedIndex = 0;
    }
    // Handle back button click (mobile only)
    backButton.addEventListener('click', function () {
        // Show form and hide back button
        searchForm.classList.remove('gas-form-menu-hidden');
        backButton.classList.remove('gas-form-back-button-visible');
        // Clear results
        clearResults();
    });
    // Handle form submission
    searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        // Validate form
        if (!validateForm()) {
            return;
        }
        // Get selected values
        const selectedUF = estadoSelect.value;
        const selectedCidade = cidadeSelect.value;
        const selectedBairro = bairroSelect.value;
        // Filter gas stations based on selection
        filterGasStations(selectedUF, selectedCidade, selectedBairro);
        // Display results
        displayResults();
    });
    // Form validation
    function validateForm() {
        let isValid = true;
        if (estadoSelect.value === '') {
            isValid = false;
            estadoSelect.focus();
            alert('Por favor, selecione um estado.');
        }
        else if (cidadeSelect.value === '') {
            isValid = false;
            cidadeSelect.focus();
            alert('Por favor, selecione uma cidade.');
        }
        else if (bairroSelect.value === '') {
            isValid = false;
            bairroSelect.focus();
            alert('Por favor, selecione um bairro.');
        }
        return isValid;
    }
    // Filter gas stations based on selection
    function filterGasStations(uf, cidade, bairro) {
        // Reset filtered stations
        filteredStations = [];
        if (bairro) {
            // Filter by neighborhood
            const neighborhoodKey = `${uf}-${cidade}-${bairro}`;
            filteredStations = neighborhoodMap[neighborhoodKey] || [];
        }
        else {
            // Filter by city
            filteredStations = allGasStations.filter(station => {
                return station.UF === uf && station.Cidade === cidade;
            });
        }
    }
    // Clear results container
    function clearResults() {
        resultsContainer.innerHTML = '';
    }
    // Display filtered gas stations
    function displayResults() {
        // Clear previous results
        clearResults();
        // Em dispositivos móveis, ocultar o formulário e mostrar o botão de voltar
        if (window.innerWidth <= 768) {
            searchForm.classList.add('gas-form-menu-hidden');
            backButton.classList.add('gas-form-back-button-visible');
        }
        // Referência à lista de resultados existente no HTML
        const resultsList = document.createElement('div');
        resultsList.className = 'gas-form-results-list';
        resultsList.id = 'gas-form-results-list';
        // Referência ao botão "Carregar mais"
        const loadMoreButton = document.createElement('button');
        loadMoreButton.type = 'button';
        loadMoreButton.className = 'gas-form-load-more';
        loadMoreButton.id = 'gas-form-load-more';
        loadMoreButton.textContent = 'Carregar mais resultados';
        if (filteredStations.length > 0) {
            // Definir quantos itens mostrar inicialmente (3 para mobile/tablet)
            const initialItems = window.innerWidth <= 768 ? 3 : filteredStations.length;
            const itemsToShow = Math.min(initialItems, filteredStations.length);
            // Adicionar os itens iniciais à lista
            for (let i = 0; i < itemsToShow; i++) {
                const resultItem = createResultItem(filteredStations[i]);
                resultsList.appendChild(resultItem);
            }
            // Adicionar evento de clique ao botão "Carregar mais"
            let currentlyShown = itemsToShow;
            loadMoreButton.addEventListener('click', function () {
                // Mostrar mais 3 itens ou o restante, o que for menor
                const moreToShow = Math.min(3, filteredStations.length - currentlyShown);
                for (let i = 0; i < moreToShow; i++) {
                    const resultItem = createResultItem(filteredStations[currentlyShown + i]);
                    resultsList.appendChild(resultItem);
                }
                currentlyShown += moreToShow;
                // Esconder o botão se todos os itens foram mostrados
                if (currentlyShown >= filteredStations.length) {
                    loadMoreButton.style.display = 'none';
                }
            });
            // Mostrar ou esconder o botão "Carregar mais" com base na quantidade de resultados
            if (window.innerWidth <= 768 && filteredStations.length > 3) {
                loadMoreButton.style.display = 'block';
            }
            else {
                loadMoreButton.style.display = 'none';
            }
        }
        else {
            // Nenhum resultado encontrado
            const noResults = document.createElement('div');
            noResults.className = 'gas-form-no-results';
            noResults.textContent = 'Nenhum posto encontrado com os critérios selecionados.';
            resultsList.appendChild(noResults);
            // Esconder o botão "Carregar mais" quando não há resultados
            loadMoreButton.style.display = 'none';
        }
        // Adicionar a lista e o botão ao container de resultados
        resultsContainer.appendChild(resultsList);
        resultsContainer.appendChild(loadMoreButton);
    }
    // Create a result item for a gas station
    function createResultItem(station) {
        const resultItem = document.createElement('div');
        resultItem.className = 'gas-form-result-item';
        // Para dispositivos móveis, criar um container para logo e info
        const topContainer = document.createElement('div');
        // Create logo
        const logoContainer = document.createElement('div');
        logoContainer.className = 'gas-form-result-logo';
        logoContainer.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="47" viewBox="0 0 50 47" fill="none">
          <path d="M22.1783 44.4097H9.99882L8.87013 35.3826L1.48406 30.0107C1.16293 28.431 1 26.823 1 25.2102C1 11.9635 11.7532 1.21021 25 1.21021C38.2468 1.21021 49 11.9611 49 25.2102C49 26.823 48.8371 28.431 48.5159 30.0107L41.1299 35.3826L40.0012 44.4097H27.8217L27.1181 44.9198C26.5018 45.3684 25.7603 45.6093 25 45.6093C24.2397 45.6093 23.4982 45.3684 22.8819 44.9198L22.1783 44.4097Z" stroke="white" stroke-width="0.81375" stroke-miterlimit="40"/>
          <path d="M22.1783 44.4097H9.99882L8.87013 35.3826L1.48406 30.0107C1.16293 28.431 1 26.823 1 25.2102C1 11.9635 11.7532 1.21021 25 1.21021C38.2467 1.21021 49 11.9611 49 25.2102C49 26.823 48.8371 28.431 48.5159 30.0107L41.1299 35.3826L40.0012 44.4097H27.8217L27.1181 44.9198C26.5018 45.3684 25.7603 45.6093 25 45.6093C24.2397 45.6093 23.4982 45.3684 22.8819 44.9198L22.1783 44.4097Z" fill="#F8CD05"/>
          <path d="M25 1.21021C11.7532 1.21021 1 11.9611 1 25.2102C1 26.823 1.16293 28.431 1.48406 30.0107L8.87013 35.3826L9.99882 44.4097H22.1783L22.8819 44.9198C23.4982 45.3684 24.2397 45.6093 25 45.6093C25.7603 45.6093 26.5018 45.3684 27.1181 44.9198L27.8217 44.4097H40.0012L41.1299 35.3826L48.5159 30.0107C48.8371 28.431 49 26.823 49 25.2102C49 11.9635 38.2467 1.21021 25 1.21021ZM43.9138 21.052C44.4994 22.3602 44.7993 23.7769 44.7993 25.2102C44.7993 26.0674 44.693 26.9221 44.4758 27.7533L37.1842 33.0567L36.2893 40.209H27.4368L26.1263 41.1606C25.7981 41.3991 25.4014 41.529 24.9976 41.529C24.5939 41.529 24.1972 41.4015 23.8689 41.1606L22.5584 40.209H13.706L12.8111 33.0567L5.51948 27.7533C5.30697 26.9221 5.19835 26.0674 5.19835 25.2102C5.19835 23.7769 5.50059 22.3602 6.08383 21.052L18.9929 34.1051L6.44274 18.6128C6.93625 16.6034 8.02951 14.7899 9.57615 13.418L20.8276 32.8348L10.8583 11.5762C12.1476 9.85956 13.9469 8.59628 15.9965 7.9611L22.8749 32.0626L17.8501 6.967C19.3778 6.10513 21.1039 5.65176 22.8607 5.65176C23.2314 5.65176 23.6021 5.67302 23.9728 5.71316L24.9976 31.81L26.0224 5.71316C26.3908 5.67302 26.7615 5.65176 27.1346 5.65176C28.889 5.65176 30.6175 6.10513 32.1452 6.967L27.1204 32.0626L33.9988 7.9611C36.0484 8.59628 37.8477 9.85956 39.1393 11.5762L29.17 32.8348L40.4191 13.418C41.9681 14.7923 43.0614 16.6034 43.5549 18.6128L31.0047 34.1051L43.9138 21.052Z" fill="#DD1D21"/>
        </svg>
      `;
        // Create info container
        const infoContainer = document.createElement('div');
        infoContainer.className = 'gas-form-result-info';
        // Create name
        const name = document.createElement('div');
        name.className = 'gas-form-result-name';
        name.textContent = station['Razao Social'];
        // Create address
        const address = document.createElement('div');
        address.className = 'gas-form-result-address';
        address.textContent = `${station.Endereco}, ${station.Bairro}, ${station.Cidade} - ${station.UF}, ${station.CEP}`;
        // Add name and address to info container
        infoContainer.appendChild(name);
        infoContainer.appendChild(address);
        // Create map button
        const mapButton = document.createElement('a');
        mapButton.className = 'gas-form-result-map-button';
        mapButton.textContent = 'Ver no Google Maps';
        mapButton.href = `https://www.google.com/maps/search/${encodeURIComponent(station['Razao Social'] + ' ' + station.Endereco + ' ' + station.Cidade + ' ' + station.UF)}`;
        mapButton.target = '_blank';
        mapButton.rel = 'noopener noreferrer';
        // Adicionar elementos ao item de resultado de acordo com o layout
        if (window.innerWidth <= 768) {
            // Mobile: logo e info lado a lado, botão abaixo
            infoContainer.appendChild(mapButton);
            topContainer.appendChild(logoContainer);
            topContainer.appendChild(infoContainer);
            resultItem.appendChild(topContainer);
        }
        else {
            // Desktop: todos os elementos na mesma linha
            resultItem.appendChild(logoContainer);
            resultItem.appendChild(infoContainer);
            resultItem.appendChild(mapButton);
        }
        return resultItem;
    }
});
